import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { graphql, useStaticQuery } from "gatsby";
import Headroom from "react-headroom";
import Link from "./link";
import Logo from "./logo";
import SocialNetworks from "./social-networks";
import Languages from "./languages";
import MainNav from "./main-nav";
import Hamburger from "./hamburger";
import Menu from "./menu";
import Alert from "./alert";

const query = graphql`
  query {
    allContentfulHome {
      nodes {
        node_locale
        mainMenuContact {
          link
          button
          buttonBackgroundColour
          id
          textColour
          title
          target
          modal {
            ...Modal
          }
        }
      }
    }
  }
`;

const Header = ({ white }) => {
  const menuTriggerRef = React.useRef(null);
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(null);
  const { allContentfulHome } = useStaticQuery(query);
  const { locale } = useIntl();

  const { mainMenuContact } = allContentfulHome.nodes.find(
    (item) => item.node_locale === locale
  );

  const toggleAlert = () => {
    setIsAlertOpen((prev) => !prev);
  };

  const closeAlert = () => {
    setIsAlertOpen(false);
  };

  const openMenu = () => {
    setIsMenuOpen(true);
    document.body.classList.add("overflow-hidden");
  };

  const closeMenu = () => {
    setIsMenuOpen(null);
    document.body.removeAttribute("class");
    menuTriggerRef.current?.focus();
  };

  const handleClick = () => (!isMenuOpen ? openMenu() : closeMenu());

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") closeMenu();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <header className={`header${white ? " header-white" : ""}`}>
      <Alert isOpen={isAlertOpen} onClose={closeAlert} />
      <div className="header-top">
        <SocialNetworks />
        <button
          className="header-alert-toggle"
          type="button"
          aria-expanded={isAlertOpen}
          aria-controls="alert"
          onClick={toggleAlert}
        >
          <FormattedMessage id="alertHeading" />
        </button>
        <Languages />
      </div>
      <div className="header-bottom">
        <Headroom pinStart={160} disableInlineStyles>
          <Link className="header-logo" href="/">
            <Logo icon />
            <Logo />
          </Link>
          <MainNav className="header-main-nav" />
          <button
            className="header-button"
            onClick={handleClick}
            aria-controls="menu"
            ref={menuTriggerRef}
          >
            <Hamburger />
          </button>
          <Link className="header-contact" href={mainMenuContact.link}>
            {mainMenuContact.title}
          </Link>
        </Headroom>
      </div>
      <Menu menu={isMenuOpen} handleClick={handleClick} />
    </header>
  );
};

export default Header;
